import React from 'react';
import PricingCard from './PricingCard';
import '../subscription-plan.scss';

const PricingSection = ({ billing, setBilling, plans }) => {
	return (
		<div className="pricing-wrapper">
			{/* Toggle */}
			<div className="billing-toggle">
				<button
					className={billing === 'monthly' ? 'active' : ''}
					onClick={() => setBilling('monthly')}
				>
					Monthly
				</button>
				<button
					className={billing === 'yearly' ? 'active' : ''}
					onClick={() => setBilling('yearly')}
				>
					Yearly
				</button>
			</div>

			{/* Cards */}
			<div className="container">
				<div className="row mx-auto">
					{plans?.map((plan, i) => (
						<div
							key={i}
							className="col-lg-3 col-md-6 col-12"
						>
							<PricingCard
								plan={plan}
								billing={billing}
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default PricingSection;
